import React from 'react';
import { makeStyles } from '@mui/styles';
import { remCalc } from '../util/style-util';
import { translate } from '../translations/translator';
import { white, resourceDarkGray, resourceDarkGray2 } from '../styles/style-constants';

const translateHome = key => translate('home', key);

type Props = {
  onClick: () => void;
};

function PLIBannerTile(props: Props) {
  const { pliBannerTile, bannerTextbox, bannerRightSide, bannerLinkRectangle } = useStyles();
  const { onClick } = props;
  return (
    <div className={pliBannerTile}>
      <div>
        <div className={bannerTextbox}>
          <span>{translateHome('pliBannerTextBeforeApp')} </span>
          <span style={{ fontWeight: 700 }}>{translateHome('pliBannerTextApp')} </span>
          <span>{translateHome('pliBannerTextAfterApp')}</span>
        </div>
        <div onClick={onClick} className={bannerRightSide}>
          <p className={bannerLinkRectangle}>{translateHome('pliBannerButton')}</p>
        </div>
      </div>
    </div>
  );
}

const useStyles = makeStyles(() => {
  return {
    pliBannerTile: {
      backgroundColor: white,
      width: '100%',
      height: remCalc(80),
      margin: remCalc(10),
      marginTop: remCalc(30),
      paddingLeft: remCalc(20),
      paddingRight: remCalc(20),
      paddingBottom: remCalc(10),
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      boxShadow: '0px 3px 7px 1px' + resourceDarkGray,
      border: remCalc(1) + ' solid' + resourceDarkGray,
      borderRadius: remCalc(3),
      justifyContent: 'space-between',
      color: resourceDarkGray2,
      userSelect: 'none'
    },
    bannerTextbox: {
      float: 'left',
      width: '80%',
      fontSize: '18px',
      paddingTop: '28px',
      verticalAlign: 'center',
      fontWeight: 300
    },
    bannerRightSide: {
      float: 'left',
      width: '12%',
      textAlign: 'center',
      paddingTop: '5px',
      color: '#2878C1',
      fontWeight: 400
    },
    bannerLinkRectangle: {
      border: '3px',
      borderStyle: 'solid',
      borderColor: '#2878C1',
      paddingTop: '10px',
      borderRadius: '8px',
      height: '30px',
      width: '225px',
      cursor: 'pointer',
      '&:hover': {
        transform: 'scale(1.05, 1.05)'
      }
    }
  };
});

export default PLIBannerTile;
